import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Typography } from 'antd'
import { Icon } from '@iconify/react';
import "./styles.css"
import { makeRequestStateless } from '../../utils/helpers';
import { getDashboardDetails } from './requests';
import DashboardMainSummary from './components/DashboardMainSummary';
import DashboardBillSummary from './components/DashboardBillSummary';

const { Title, Text } = Typography

export default function Dashboard() {

  const [dashboardDetail, setDashboardDetail] = useState([]);

  useEffect(() => {
    loadData()
  }, [])


  const loadData = async () => {
    await makeRequestStateless(getDashboardDetails, false, onSuccess, onError)
  }

  const onSuccess = (res) => {
    setDashboardDetail(res)
  }

  const onError = (err) => {
    console.error(err);
  }

  return (
    <div>
      <Title level={ 3 }>Dashboard</Title>
      <Text type='secondary'>Displays analytics about sass, outlets, orders and many more</Text>
      <DashboardMainSummary records={ dashboardDetail } />
      <DashboardBillSummary records={ dashboardDetail } />
    </div>
  )
}
